import actions from './actions'

export default function ContractServicePartnersReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_CONTRACTSERVICEPARTNER:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_CONTRACTSERVICEPARTNER:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CONTRACTSERVICEPARTNER:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_CONTRACTSERVICEPARTNER:
      return {
        ...state,
        editing: { contractServicePartnerID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.SAVE_CONTRACTSERVICEPARTNER_RECIEVED:
    case actions.DELETE_CONTRACTSERVICEPARTNER_RECIEVED:
      return {
        ...state,
        editing: { contractServicePartnerID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
